import { queryOptions } from '@tanstack/react-query'
import { authApi, type AuthResponse, type SessionUser } from './auth-api'

export type Session = {
  isAuthenticated: boolean
  user: SessionUser | null
}

export function sessionFromResponse(response: AuthResponse): Session {
  return {
    isAuthenticated: response.meta?.is_authenticated ?? false,
    user: response.data?.user ?? null,
  }
}

export const sessionQuery = queryOptions({
  queryKey: ['auth', 'session'],
  queryFn: async () => sessionFromResponse(await authApi.getSession()),
  staleTime: 60_000,
})
